import CacheWithExpiration from './cacheWithExpiration';
import MemoryStorage from './memoryStorage';

export default class MemoryCache extends CacheWithExpiration {
  constructor() {
    super(new MemoryStorage());
  }
}
